import { checkAgentHubStatusByAgentToken } from 'actions/AgentHubActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

const EmptyList: App.AgentHubAgentStatus = {
  fetching: false,
  error: undefined,
  data: {
    status: '',
    agentId: '',
    action: '',
  },
}

type AgentStatusProps = {
  registrationToken: string
}

function useAgentHubAgentStatus({ registrationToken }: AgentStatusProps): App.AgentHubAgentStatus {
  const dispatch = useAppDispatch()

  const agentStatus = useAppSelector(state => state.agentHub.agentStatus[registrationToken]) ?? EmptyList

  useEffect(() => {
    if (registrationToken) {
      dispatch(checkAgentHubStatusByAgentToken(registrationToken))
      return
    }
  }, [registrationToken, dispatch])

  if (registrationToken === '') {
    return {
      fetching: false,
      error: 'No agent token provided',
      data: {
        status: '400',
        agentId: '',
        action: '',
        hasAgencyId: false,
      },
    }
  }

  return agentStatus
}

export default useAgentHubAgentStatus
